import { TeButton } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';

export enum CustomApplicationStepEnum {
  BasicInfo,
  AuthInfo,
}

interface CreateCustomApplicationStepActionsProps {
  onClose: (shouldUpdate: boolean) => void;
  isPending: boolean;
  isNextStepDisabled: boolean;
  currentStep: CustomApplicationStepEnum;
  totalSteps: number;
  confirmText: string;
  onPreviousStep: (key: CustomApplicationStepEnum) => void;
  onNextStep: (key: CustomApplicationStepEnum) => void;
  onSubmit: () => void;
}

function CreateCustomApplicationStepActions({
  onClose,
  isPending,
  currentStep,
  totalSteps,
  confirmText,
  isNextStepDisabled,
  onPreviousStep,
  onNextStep,
  onSubmit,
}: CreateCustomApplicationStepActionsProps) {
  const { t } = useTranslation();
  return (
    <>
      {/* Cancel button */}
      {currentStep === 0 && (
        <TeButton
          slot="tertiary"
          text={t('cancel', { ns: 'common' })}
          variant="neutral"
          teclick={() => onClose(false)}
          size="s"
          disabled={isPending}
        />
      )}
      {/* Previous step button */}
      {currentStep > 0 && (
        <TeButton
          slot="tertiary"
          text={t('step.previous', { ns: 'common' })}
          variant="neutral"
          teclick={() => onPreviousStep(currentStep - 1)}
          size="s"
          disabled={isPending}
        />
      )}
      {/* Next step button */}
      {currentStep !== totalSteps - 1 && (
        <TeButton
          slot="primary"
          text={t('step.next', { ns: 'common' })}
          variant="primary"
          teclick={() => onNextStep(currentStep + 1)}
          size="s"
          disabled={isPending || isNextStepDisabled}
          loading={isPending}
        />
      )}
      {/* Create custom application button */}
      {currentStep === CustomApplicationStepEnum.AuthInfo && (
        <TeButton
          text={confirmText}
          variant="primary"
          slot="primary"
          teclick={onSubmit}
          size="s"
          disabled={isPending || isNextStepDisabled}
          loading={isPending}
        />
      )}
    </>
  );
}

export { CreateCustomApplicationStepActions };
